// API クライアント。クッキー認証なので credentials: 'include'。
async function request<T = any>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
    },
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    let msg = `HTTP ${res.status}`
    try { const j = JSON.parse(text); if (j.error) msg = j.error } catch { /* */ }
    throw new Error(msg)
  }
  return res.json()
}

export const auth = {
  checkSetup: () => request<{ needsSetup: boolean }>('/auth/check-setup'),
  setup: (data: { email: string; name: string; password: string }) =>
    request<{ ok: true; user: AuthUser }>('/auth/setup', { method: 'POST', body: JSON.stringify(data) }),
  login: (email: string, password: string) =>
    request<{ ok: true; user: AuthUser }>('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  me: () => request<{ user: AuthUser }>('/auth/me'),
  logout: () => request('/auth/logout', { method: 'POST' }),
}

export const clients = {
  list: () => request<{ clients: Client[] }>('/clients'),
  create: (data: { name: string; baseUrl: string; advisorToken: string; adminEmail: string; memo?: string; displayOrder?: number }) =>
    request<{ ok: true; id: string }>('/clients', { method: 'POST', body: JSON.stringify(data) }),
  update: (data: Partial<Client> & { id: string; advisorToken?: string }) =>
    request<{ ok: true }>('/clients', { method: 'PUT', body: JSON.stringify(data) }),
  remove: (id: string) =>
    request<{ ok: true }>('/clients', { method: 'DELETE', body: JSON.stringify({ id }) }),
  summary: (id: string) =>
    request<ClientSummary>(`/clients/${id}/summary`),
  sso: (id: string) =>
    request<{ ok: true; ssoUrl: string }>(`/clients/${id}/sso`, { method: 'POST' }),
}

export interface AuthUser { id: string; email: string; name: string }
export interface Client {
  id: string; name: string; baseUrl: string; adminEmail: string;
  memo: string; displayOrder: number; hasToken?: boolean;
}
export interface ClientSummary {
  balance: number;
  monthIncome: number;
  monthExpense: number;
  monthDiff: number;
  dangerDate?: string | null;
  dangerBalance?: number | null;
  updatedAt?: string | null;
}
